import { makeStyles } from '@mui/styles';
export const useStyles = makeStyles(() => ({
  containButton: {
    '& > *': {
      margin: `5px 10px`,
    },
  },
  chip: {
    marginBottom: 8,
    marginInlineEnd: 5,
    backgroundColor: '#b3e5fc',
    '&:hover': {
      backgroundColor: '#8fcce8',
    },
  },
  chipLabel: { fontSize: 12 },
  errorMessage: {
    fontSize: '11px',
    color: 'red',
  },
  addVoucherWrapper: {
    marginTop: 30,
  },
}));